import * as Types from "../../../graphql/schemaTypes.generated";

import gql from "graphql-tag";
export type BankAccountFieldsForUploadFragment = {
  __typename?: "bank_accounts";
} & Pick<
  Types.Bank_Accounts,
  | "product_type"
  | "account_id"
  | "account_description"
  | "fixed_maturity_date"
  | "opening_interest_rate"
  | "notice_days"
> & {
    bank?: Types.Maybe<{ __typename?: "banks" } & Pick<Types.Banks, "name">>;
    currency: { __typename?: "currencies" } & Pick<Types.Currencies, "prefix">;
    actual_balances: Array<
      { __typename?: "actual_balances" } & Pick<
        Types.Actual_Balances,
        "balance" | "date" | "created_at"
      >
    >;
    currency_book: { __typename?: "currency_books" } & {
      business_unit: { __typename?: "business_units" } & {
        organisation: { __typename?: "organisations" } & Pick<
          Types.Organisations,
          "name"
        >;
      };
    };
  };

export const BankAccountFieldsForUploadFragmentDoc = gql`
  fragment bankAccountFieldsForUpload on bank_accounts {
    product_type
    account_id
    account_description
    fixed_maturity_date
    opening_interest_rate
    notice_days
    bank {
      name
    }
    currency {
      prefix
    }
    actual_balances(limit: 1, order_by: [{ date: desc }]) {
      balance
      date
      created_at
    }
    currency_book {
      business_unit {
        organisation {
          name
        }
      }
    }
  }
`;
